require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-tagesoeffnungszeiten-oeff-tag-3-6-j-2023-24.json") })
        }
      }, "path---kriterien-tagesoeffnungszeiten-oeff-tag-3-6-j-2023-24");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-tagesoeffnungszeiten-oeff-tag-3-6-j-2023-24!./.cache/json/kriterien-tagesoeffnungszeiten-oeff-tag-3-6-j-2023-24.json
// module id = 1123
// module chunks = 231608221292675